import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout, Spin } from "antd";
import Navigation from "./components/shared/Navigation";
import Footer from "./components/shared/Footer";
import "./assets/styles/App.css";
import { useScrollToTop } from "./utils/hooks/useScrollToTop";

const Home = lazy(() => import("./pages/Home"));
const Education = lazy(() => import("./pages/Education"));
const Projects = lazy(() => import("./pages/Projects"));
const Research = lazy(() => import("./pages/Research"));
const Experience = lazy(() => import("./pages/Experience"));
const About = lazy(() => import("./pages/About"));
const Skills = lazy(() => import("./pages/Skills"));

const { Content } = Layout;

const PageLoader = () => (
  <div style={{ textAlign: "center", padding: "80px 0" }}>
    <Spin size="large" />
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
      </Router>
    </HelmetProvider>
  );
}

function AppContent() {
  useScrollToTop();

  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      <Navigation />
      <Content className="main-content">
        <div className="site-content">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/education" element={<Education />} />
              <Route path="/skills" element={<Skills />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/research" element={<Research />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </Suspense>
        </div>
      </Content>
      <Footer />
    </Layout>
  );
}

export default App;
